import { ALL } from '../../../../config/constants';
import {
  addMediaFiles,
  removeMediaLibraryFiles
} from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import {
  getMediaInfo,
  uploadExternalMediaFiles
} from '../../../../redux/slices/bulkPostsImport/helpers';
import { validateAllUpload, validateUpload } from '../../config/postValidator';
import { createMockFile } from '../../utils/helpers';
import { buildExternalMediaItem } from './externalMediaImportUtils';

export const handleMediaLibraryFileChange = async (
  files: any,
  dispatch: any,
  t: any,
  postDataMediaFiles: any,
  platform: any,
  typeKey: any,
  typeKeyAll: any,
  platformEnabled: any,
  newUpload = true
) => {
  if (!files) {
    return;
  }

  const fileList = files; // This is a FileList
  const getObjectAsFile = (item) => {
    const mockFileData = {
      original_filename: item?.name,
      file_type: item?.file_type,
      file_size: item?.file_size,
      original_asset: item?.original_asset,
      video_audio_channels: item?.video_audio_channels,
      pdf_page_count: item?.pdf_page_count
    };

    const mockFile = createMockFile(mockFileData);
    return mockFile;
  };
  const fileArray = fileList.map((item) => getObjectAsFile(item));

  const prevUploadedFiles = postDataMediaFiles.map((item) =>
    item?.file ? item?.file : getObjectAsFile(item)
  );

  const total_file_array = [...prevUploadedFiles, ...fileArray];

  dispatch(
    removeMediaLibraryFiles({
      platform
    })
  );

  const is_valid = async () => {
    try {
      const validationState =
        platform === ALL
          ? await validateAllUpload(
              platform,
              typeKeyAll,
              total_file_array,
              t,
              dispatch,
              platformEnabled
            )
          : await validateUpload(platform, typeKey, total_file_array, t);

      return validationState;
    } catch (error) {
      console.error('Validation error:', error.message);
      return false; // or you could return an error object, or handle it however you need to
    }
  };

  if (await is_valid()) {
    dispatch(
      addMediaFiles({
        platform,
        files: fileList
          .map((file) => {
            return {
              ...file,

              id: `${file?.uuid}`,

              file: getObjectAsFile(file),

              uploadPreset: null,

              assetBlob: null,
              saved_in_media_library: true,
              uploaded: true,
              isUploading: false,
              editorUpdateState: newUpload,
              previewImageURL: file?.preview_image,
              newUpload: newUpload
            };
          })
          .filter((file) => file !== null)
      })
    );
  }

  console.log('continue executing function');
};

export const handleBrowserPluginFileChange = async (
  files: any,
  dispatch: any,
  t: any,
  postDataMediaFiles: any,
  platform: any,
  typeKey: any,
  typeKeyAll: any,
  platformEnabled: any,
  newUpload = false
) => {
  if (!files) {
    return;
  }

  const fileList = files; // This is a FileList
  const getObjectAsFile = (item) => {
    const mockFileData = {
      original_filename: item?.name,
      file_type: item?.file_type,
      file_size: item?.file_size,
      original_asset: item?.original_asset,
      video_audio_channels: item?.video_audio_channels,
      pdf_page_count: item?.pdf_page_count
    };

    const mockFile = createMockFile(mockFileData);
    return mockFile;
  };
  const fileArray = fileList.map((item) => getObjectAsFile(item));

  const prevUploadedFiles = postDataMediaFiles.map((item) =>
    item?.file ? item?.file : getObjectAsFile(item)
  );

  const total_file_array = [...prevUploadedFiles, ...fileArray];

  dispatch(
    removeMediaLibraryFiles({
      platform
    })
  );

  const is_valid = async () => {
    try {
      const validationState =
        platform === ALL
          ? await validateAllUpload(
              platform,
              typeKeyAll,
              total_file_array,
              t,
              dispatch,
              platformEnabled
            )
          : await validateUpload(platform, typeKey, total_file_array, t);

      return validationState;
    } catch (error) {
      console.error('Validation error:', error.message);
      return false; // or you could return an error object, or handle it however you need to
    }
  };

  if (await is_valid()) {
    dispatch(
      addMediaFiles({
        platform,
        files: fileList
          .map((file) => {
            return {
              ...file,

              file: getObjectAsFile(file),

              assetBlob: null,

              uploaded: true,
              isUploading: false,
              editorUpdateState: newUpload,
              previewImageURL: file?.preview_image,
              newUpload: newUpload
            };
          })
          .filter((file) => file !== null)
      })
    );
  }

  console.log('continue executing function');
};

export const handleSingleExternalFileUpload = async (
  mediaLink: string,
  location_uuid: string,
  cloud_uuid: string
) => {
  const [media] = await getMediaInfo([mediaLink]);
  if (!media) {
    throw new Error('Unable to resolve the external media metadata.');
  }

  const [uploadedMedia] = await uploadExternalMediaFiles(
    [media],
    [mediaLink],
    location_uuid,
    cloud_uuid,
    true
  );

  if (!media || !uploadedMedia) {
    throw new Error('Unable to upload the external media file.');
  }

  return buildExternalMediaItem(uploadedMedia, media);
};
